import "core-js/modules/es.object.to-string.js";
export function checkIsSelectionShareable(_ref) {
  var items = _ref.items;
  if (items.some(function (item) {
    return item.type === 'section';
  })) {
    return false;
  }

  // Check if all items are of type playlist
  if (items.every(function (item) {
    return item.type === 'playlist';
  })) {
    return true;
  }

  // Check if all items are asset types
  if (items.every(function (item) {
    return item.type !== 'playlist' && item.type !== 'section';
  })) {
    return true;
  }
  return false;
}